import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import axios from "axios";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import { alert, confirm } from 'devextreme/ui/dialog';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { custom } from 'devextreme/ui/dialog';
import ValidationSummary from 'devextreme-react/validation-summary';
import GenerateItemTasksRecordsTab from './tabs/GenerateItemTasksRecordsTab';
import HelpTab from './tabs/HelpTab';
function GenerateItemTaskForm(props) {
    const initialFormFields = {
        GenerationMethod: props.transactionType === 'R' ? 'S' : 'T',
        PutawayWorker: props.putAwayBy,
        UnloadWorker: props.unLoadBy,
        RFgroup: '',
        RWarehouse: props.stagingWarehouse,
        RLocatoin: props.stagingArea,
        RCaactivityPutawayby: props.RCaactivityPutawayby,
        RCaactivityUnloadby: props.RCaactivityUnloadby,
        RCaactivityLoadby: props.RCaactivityLoadby,
        RCaactivityPickby: props.RCaactivityPickby,
        TransactionHeaderRowId: props.TransactionHeaderRowId
    };

    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [formFields, setformFields] = useState(initialFormFields);
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    const formRefs = useRef({});
    const handleFormSubmit = async (e) => {
        setLoadPanelVisible(true);
        setIsFormSubmitted(true);
        try {
            e.preventDefault();
            await GenerateTransactionItemTasks();

        } catch (error) {
            console.error('Error submitting form:', error);
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    const GenerateTransactionItemTasks = async () => {
        try {
            const url = "wm/TransactionHeaderOperations/GenerateTasks";
            let fields = formFields;
            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${url}`, fields, {
                headers: {
                    'Content-Type': 'application/json',
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });

            if (response.data.success) {
                alert(response.data.message,"Success");
                setIsFormSubmitted(false);
                props.setShowGenerateItemTasksRecordsPopup(false);
            } else {
                alert(response.data.message,"Error");
                setIsFormSubmitted(false);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            if (error.response.data.ERRORS && error.response.data.ERRORS.length > 0) {
                const errorHtml = error.response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
            }
            else {
                alert("An error occurred","Error");
            }
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);

        }
    };

    const primaryFormLookupsLoad = () => {
        handleGenerateItemTasksRecordsFormLoad();
    }
    const handleGenerateItemTasksRecordsFormLoad = () => {
        if (props.transactionType == "R") {
            loadLookupFromStaticData(formRefs, "GenerationMethod", [{ id: 'P', name: "Receipt Direct - Putaway" }, { id: 'S', name: "Receipt Stage - Putaway" }]);

        } else {
            loadLookupFromStaticData(formRefs, "GenerationMethod", [{ id: 'T', name: "Shipment Direct - Pick" }, { id: 'U', name: "Shipment Stage - Pick" }]);
        }
        if (formRefs.current["UnloadWorker"]) {
            formRefs.current["UnloadWorker"].instance().option('disabled', true);
        }
        if (formRefs.current["RWarehouse"]) {
            formRefs.current["RWarehouse"].instance().option('disabled', true);
        }
        if (formRefs.current["RLocatoin"]) {
            formRefs.current["RLocatoin"].instance().option('disabled', true);
        }
        if (formRefs.current["RCaactivityUnloadby"]) {
            formRefs.current["RCaactivityUnloadby"].instance().option('disabled', true);
        }
    }
    const loadLookupFromStaticData = (formRefs, name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'id');
            formRefs.current[name].instance().option('displayExpr', 'name');
            if (formFields[name])
                formRefs.current[name].instance().option('value', formFields[name]);
        }
    };
    const handleReset = () => {
        setformFields(initialFormFields);
        props.setShowGenerateItemTasksRecordsPopup(false);
    };
    const goBack = () => {
        history.push("/wm/codes/lot-data-entry");
    };
    const handleFieldChange = useCallback((name, value, e) => {
        if (name == "GenerationMethod") {
            if (value == "S" || value == "U") {
                if (formRefs.current["UnloadWorker"]) {
                    formRefs.current["UnloadWorker"].instance().option('disabled', false);
                }
                if (formRefs.current["RWarehouse"]) {
                    formRefs.current["RWarehouse"].instance().option('disabled', false);
                }
                if (formRefs.current["RLocatoin"]) {
                    formRefs.current["RLocatoin"].instance().option('disabled', false);
                }
                if (formRefs.current["RCaactivityUnloadby"]) {
                    formRefs.current["RCaactivityUnloadby"].instance().option('disabled', false);
                }
            }
            else {
                if (formRefs.current["UnloadWorker"]) {
                    formRefs.current["UnloadWorker"].instance().option('disabled', true);
                }
                if (formRefs.current["RWarehouse"]) {
                    formRefs.current["RWarehouse"].instance().option('disabled', true);
                }
                if (formRefs.current["RLocatoin"]) {
                    formRefs.current["RLocatoin"].instance().option('disabled', true);
                }
                if (formRefs.current["RCaactivityUnloadby"]) {
                    formRefs.current["RCaactivityUnloadby"].instance().option('disabled', true);
                }
            }

        }

    });
    const handleSelectionChange = useCallback((name, e) => {
    }, []);
    return (
        <div>
            <div className="row dataEntryMainPage">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <form onSubmit={(e) => handleFormSubmit(e)}>
                            <Toolbar className="header">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2,
                                                marginLeft: '12px'
                                            }}
                                        >
                                            Generate Item Tasks Records
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button
                                        text="Generate Tasks"
                                        useSubmitBehavior={true}
                                        disabled={isFormSubmitted}
                                        type="default"
                                        className="accordianButton"
                                    />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Cancel" />
                                </Item>
                            </Toolbar>
                            <TabPanel deferRendering={props.id ? true : false} showNavButtons={true} height={"auto"}>
                                <TabItem title="Taks">
                                    <GenerateItemTasksRecordsTab formFields={formFields} setformFields={setformFields} handleFieldChange={handleFieldChange} handleSelectionChange={handleSelectionChange} primaryFormLookupsLoad={primaryFormLookupsLoad} formRefs={formRefs} />
                                </TabItem>
                                <TabItem title="Help">
                                    <HelpTab />
                                </TabItem>

                            </TabPanel>
                            <div className="row">
                                <ValidationSummary className="pl-3 pt-1" id="summary" />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(GenerateItemTaskForm);
